import React from 'react';
import { MDBDataTable, MDBPageItem, MDBPageNav, MDBPagination } from 'mdbreact';
import dayjs from 'dayjs';
import { Badge, Button } from 'reactstrap';

const columns = [
  {
    label: 'Image',
    field: 'image',
    sort: 'disabled',
    width: 150,
  },
  {
    label: 'Vegetable',
    field: 'vegetable',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Farmer',
    field: 'farmer',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'District',
    field: 'district',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Weight',
    field: 'weight',
    sort: 'asc',
    width: 270,
  },
  {
    label: 'Price',
    field: 'price',
    sort: 'asc',
    width: 270,
  },

  {
    label: 'Created At',
    field: 'createdAt',
    sort: 'asc',
    width: 100,
  },

  {
    label: 'Status',
    field: 'status',
    sort: 'asc',
    width: 100,
  },
  {
    label: 'Action',
    field: 'actions',
    sort: 'disabled',
    width: 100,
  },
];
const MundiAds = (props) => {
  return (
    <>
      <MDBDataTable
        btn
        responsive
        bordered
        searching={false}
        paging={false}
        data={{
          columns: columns,
          rows: props?.ads?.map((x) => ({
            farmer: x?.farmer?.name,

            vegetable: x?.vegetable?.name,
            weight: x?.weightUnit + ' ' + x?.weight,
            price: 'Rs ' + x?.price,
            status: x?.isActive ? 'Active' : 'In-Active',
            image: <img src={x?.image} className="rounded-circle avatar-sm card-img" />,
            district: x?.district.name,
            createdAt: dayjs(x.createdAt).format('DD/MM/YYYY'),

            actions: (
              <>
                <Button size="sm" color="warning" onClick={() => props.viewBids(x)}>
                  View Bids
                </Button>
              </>
            ),
          })),
        }}
      />
      <MDBPagination className="mb-5 justify-content-center">
        <MDBPageItem disabled={props?.currentPage === 1}>
          <MDBPageNav onClick={props?.handlePrev} className="page-link-custom">
            &laquo;
          </MDBPageNav>
        </MDBPageItem>
        {props?.renderPageNumbers}
        <MDBPageItem disabled={props?.currentPage === props?.pagesAmount}>
          <MDBPageNav onClick={props?.handleNext} className="page-link-custom">
            &raquo;
          </MDBPageNav>
        </MDBPageItem>
      </MDBPagination>
    </>
  );
};

export default MundiAds;
